import { useState } from "react";
import {
    Button,
    Card,
    CardBody,
    Form,
    FormGroup,
    Input,
    Label,
    Spinner
} from "reactstrap";
import { toast } from "react-toastify";
import { register } from "../../../common/auth/service/authApi";
import "./InlineRegisterForm.css";

interface Props {
    inline?: boolean;
    onRegisterSuccess?: () => void;
}

const InlineRegisterForm = ({ inline = false, onRegisterSuccess }: Props) => {


    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({

        name: "",

        email: "",

        phoneNumber: "",

        gender: "Male",

        password: "",

        confirmPassword: ""

    });
    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {

        setFormData({

            ...formData,

            [e.target.name]:
                e.target.value

        });

    };
    const handleSubmit = async (
        e: React.FormEvent
    ) => {

        e.preventDefault();

        if (!formData.name.trim())
            return toast.error("Name is required");

        if (!formData.email.trim())
            return toast.error("Email is required");

        if (!formData.phoneNumber.trim())
            return toast.error("Phone Number is required");

        if (!formData.password)
            return toast.error("Password is required");

        if (
            formData.password !==
            formData.confirmPassword
        )
            return toast.error("Passwords do not match");

        try {

            setLoading(true);

            await register({

                name: formData.name,

                email: formData.email,

                password: formData.password,

                gender: "Male",

                phoneNumber:
                    formData.phoneNumber,

                role: 4

            });


            onRegisterSuccess?.();

            if (inline) {

                onRegisterSuccess?.();

                return;

            }

        }
        catch (error: any) {

            toast.error(

                error?.response?.data?.message ||

                "Registration failed"

            );

        }
        finally {

            setLoading(false);

        }

    };

    const content = (

        <>

           <div
  style={{
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
    marginTop:"-50px"
  }}
>
  <div
    className="w-100"
    style={{
      maxWidth: "680px",
    }}
  >
    <div
      style={{
        background: "#fff",
        borderRadius: "24px",
        padding: "35px",
        boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
      }}
    >
      <div  className="text-center mb-4">
        <div
          style={{
            width: "70px",
            height: "70px",
            borderRadius: "50%",
            background: "linear-gradient(135deg,#2563eb,#4f46e5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 20px",
            color: "#fff",
            fontSize: "28px",
            fontWeight: "bold",
          }}
        >
          PW
        </div>

        <h2 className="fw-bold mb-2">Join PriceWorth</h2>

        <p className="text-muted">
          Create your account in less than a minute.
        </p>
      </div>

      <Form onSubmit={handleSubmit}>

        <FormGroup floating className="mb-3">
          <Input
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder=""
            style={{
              borderRadius: "12px",
              height: "58px",
            }}
          />
          <Label>Name</Label>
        </FormGroup>

        <FormGroup floating className="mb-3">
          <Input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder=""
            style={{
              borderRadius: "12px",
              height: "58px",
            }}
          />
          <Label>Email Address</Label>
        </FormGroup>

        <FormGroup floating className="mb-3">
          <Input
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleChange}
            placeholder=""
            style={{
              borderRadius: "12px",
              height: "58px",
            }}
          />
          <Label>Phone Number</Label>
        </FormGroup>

        <FormGroup floating className="mb-3">
          <Input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            placeholder=""
            style={{
              borderRadius: "12px",
              height: "58px",
            }}
          />
          <Label>Password</Label>
        </FormGroup>

        <FormGroup floating className="mb-4">
          <Input
            type="password"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            placeholder=""
            style={{
              borderRadius: "12px",
              height: "58px",
            }}
          />
          <Label>Confirm Password</Label>
        </FormGroup>

        <Button
          type="submit"
          disabled={loading}
          className="w-100 fw-bold"
          style={{
            height: "55px",
            borderRadius: "14px",
            fontSize: "17px",
            border: "none",
            background: "linear-gradient(135deg,#2563eb,#4f46e5)",
          }}
        >
          {loading ? (
            <>
              <Spinner size="sm" className="me-2" />
              Creating Account...
            </>
          ) : (
            "Create Account"
          )}
        </Button>

        <div className="text-center mt-4">
          <small className="text-muted">
            Already have an account?{" "}
            <a
              href="/login"
              style={{
                color: "#2563eb",
                textDecoration: "none",
                fontWeight: 600,
              }}
            >
              Sign In
            </a>
          </small>
        </div>

      </Form>
    </div>
  </div>
</div>


        </>

    );

    if (inline) {
        return (
            <Card
                className="border-0 shadow-lg"
                style={{
                    borderRadius: "20px",
                    background: "linear-gradient(135deg,#5eadee,#2b7cd3)",
                }}
            >
                <CardBody className="p-5" style={{
                    width:"85%",margin:'0 auto'
                }}>
                    {content}
                </CardBody>
            </Card>
        );
    }
    return content;

};

export default InlineRegisterForm;